module.exports = __webpack_public_path__ + "static/img/1.e6791e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-es/1.jpg
// module id = MEdh
// module chunks = 1